import { ZodRealError } from "./errors.js";
import { _parse, _safeParse, _parseAsync, _safeParseAsync } from "./parse2.js";
const parse = /* @__PURE__ */ _parse(ZodRealError);
const parseAsync = /* @__PURE__ */ _parseAsync(ZodRealError);
const safeParse = /* @__PURE__ */ _safeParse(ZodRealError);
const safeParseAsync = /* @__PURE__ */ _safeParseAsync(ZodRealError);
export {
  parse,
  parseAsync,
  safeParse,
  safeParseAsync
};
//# sourceMappingURL=parse.js.map
